module.exports = __webpack_public_path__ + "images/splash-group-1.5-scale.png";